export default "__VITE_ASSET__Be3S_4mK__"